export default "__VITE_ASSET__DOpYHArl__"